class HyCollapsible extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.initAttemps = 0; // if init fails, wait for content to be rendered
        this.init();
    }
    init(){
        this.initAttemps += 1;
        this.trigger = this.querySelector("[collapsible_trigger]"); //open/close collapsible
        this.content = this.querySelector("[collapsible_content]"); // collappible content
        if(!!this.trigger && !!this.content){
            //console.log('trigger and content found')
            //responsive height for content (screen size);
            window.addEventListener('resize', (e)=>{
                if(!this.hasAttribute('closed')){
                    this.style.maxHeight = `${this.trigger.offsetHeight + this.content.offsetHeight}px`;
                }
            })
            //initially content is hidden, render with max height of trigger to create height transition
            this.style.maxHeight= `${this.trigger.offsetHeight}px`;

            this.content.classList.remove('init_hidden');
            this.trigger.onclick = ()=>{
                this.toggleAttribute('closed');
                let showContent = true;
                if(this.hasAttribute('closed')){
                    showContent = false;
                }
                this.toggleContent(showContent);
            }
        } else {
            if(this.initAttemps < 3){
                setTimeout(()=> {
                    this.init();
                }, 1000)
            } else {
                console.error('Failed to init HyCollapsible')
            }
        }
    }
    toggleContent(showContent){
        if(showContent){
            this.style.maxHeight = `${this.trigger.offsetHeight + this.content.offsetHeight}px`;
        }else {
            this.style.maxHeight = `${this.trigger.offsetHeight}px`;
        }
    }
}
customElements.define("hy-collapsible", HyCollapsible);
